
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['click'],
    setup(props, { emit }) {
        const onClick = (event: MouseEvent) => {
            if (props.disabled) return
            emit('click', event)
        }

        return {
            onClick
        }
    }
})
